import React, { useState, useEffect } from 'react';
import femaleAgent from './assets/female_agent.png';
import './AnimatedCharacter.css';

const AnimatedCharacter = ({ isSpeaking }) => {
  const [showThinkingBubble, setShowThinkingBubble] = useState(false);
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    if (isSpeaking) {
      setShowThinkingBubble(true);
      // Clear any existing timer to prevent premature disappearance
      if (timerId) {
        clearTimeout(timerId);
      }
      // Set a new timer to hide the bubble after 3 seconds
      const newTimerId = setTimeout(() => {
        setShowThinkingBubble(false);
        setTimerId(null); // Reset timer ID state
      }, 3000);
      setTimerId(newTimerId);
    }
    // Clean up function to clear the timer
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [isSpeaking, timerId]);

  return (
    <div className="animated-character">
      <img src={femaleAgent} alt="Customer Support Agent" />
      {showThinkingBubble && <div className="thinking-bubble"><span>...</span></div>}
    </div>
  );
};

export default AnimatedCharacter;



// import React, { useState, useEffect } from 'react';
// import femaleAgent from './assets/female_agent.png'; // Make sure path is correct
// import './AnimatedCharacter.css'; // Ensure CSS is correctly imported

// const AnimatedCharacter = ({ isSpeaking }) => {
//   const [showThinkingBubble, setShowThinkingBubble] = useState(false);

//   useEffect(() => {
//     if (isSpeaking) {
//       setShowThinkingBubble(true);
//       const timer = setTimeout(() => {
//         setShowThinkingBubble(false); // Hide after 3 seconds
//       }, 3000); // Set to 3000 milliseconds

//       return () => clearTimeout(timer); // Clear the timer when isSpeaking changes
//     } else {
//       // If not speaking, ensure the bubble is not shown
//       setShowThinkingBubble(false);
//     }
//   }, [isSpeaking]);

//   return (
//     <div className="animated-character">
//       <img src={femaleAgent} alt="Customer Support Agent" />
//       {showThinkingBubble && <div className="thinking-bubble"><span>...</span></div>}
//     </div>
//   );
// };

// export default AnimatedCharacter;







// import React, { useState, useEffect } from 'react';
// import femaleAgent from './assets/female_agent.png'; // Ensure the path is correct
// import './AnimatedCharacter.css'; // Ensure the CSS file is correctly linked

// const AnimatedCharacter = ({ isSpeaking }) => {
//   const [showThinkingBubble, setShowThinkingBubble] = useState(false);
//   const [animate, setAnimate] = useState(false);

//   useEffect(() => {
//     let bubbleTimer, hideBubbleTimer;

//     if (isSpeaking) {
//       setAnimate(true); // Start the animation
//       setShowThinkingBubble(true); // Show the thinking bubble immediately when speaking starts

//       // Ensure the thinking bubble is displayed for at least 3 seconds
//       bubbleTimer = setTimeout(() => {
//         setAnimate(false);
//       }, 3000);

//       hideBubbleTimer = setTimeout(() => {
//         setShowThinkingBubble(false);
//       }, 3000);

//     } else {
//       // Additional timeout to manage rapid toggling of isSpeaking
//       setTimeout(() => {
//         setShowThinkingBubble(false);
//         setAnimate(false);
//       }, 3000);
//     }

//     return () => {
//       clearTimeout(bubbleTimer);
//       clearTimeout(hideBubbleTimer);
//     };
//   }, [isSpeaking]);

//   return (
//     <div className="animated-character">
//       <img src={femaleAgent} alt="Customer Support Agent" />
//       {showThinkingBubble && <div className="thinking-bubble"><span>...</span></div>}
//     </div>
//   );
// };

// export default AnimatedCharacter;





// import React, { useState, useEffect } from 'react';
// import femaleAgent from './assets/female_agent.png'; // Ensure the path is correct
// import './AnimatedCharacter.css'; // Ensure the CSS file is correctly linked

// const AnimatedCharacter = ({ isSpeaking }) => {
//   const [showThinkingBubble, setShowThinkingBubble] = useState(false);
//   const [animate, setAnimate] = useState(false);

//   useEffect(() => {
//     let bubbleTimer, hideBubbleTimer;

//     if (isSpeaking) {
//       setAnimate(true); // Start the animation
//       setShowThinkingBubble(true); // Show the thinking bubble immediately when speaking starts

//       // Ensure the thinking bubble is displayed for at least 3 seconds
//       bubbleTimer = setTimeout(() => {
//         setAnimate(false);
//       }, 3000);

//       hideBubbleTimer = setTimeout(() => {
//         setShowThinkingBubble(false);
//       }, 3000);

//     } else {
//       // Additional timeout to manage rapid toggling of isSpeaking
//       setTimeout(() => {
//         setShowThinkingBubble(false);
//         setAnimate(false);
//       }, 3000);
//     }

//     return () => {
//       clearTimeout(bubbleTimer);
//       clearTimeout(hideBubbleTimer);
//     };
//   }, [isSpeaking]);

//   return (
//     <div className="animated-character">
//       <img src={femaleAgent} alt="Customer Support Agent" />
//       {showThinkingBubble && <div className="thinking-bubble"><span>...</span></div>}
//     </div>
//   );
// };

// export default AnimatedCharacter;


// import React, { useState, useEffect } from 'react';
// import femaleAgent from './assets/female_agent.png'; // Ensure the path is correct

// const AnimatedCharacter = ({ isSpeaking }) => {
//   const [showThinkingBubble, setShowThinkingBubble] = useState(false);
//   const [animate, setAnimate] = useState(false);

//   useEffect(() => {
//     let bubbleTimer, hideBubbleTimer;

//     if (isSpeaking) {
//       setAnimate(true); // Start the animation
//       setShowThinkingBubble(true); // Show the thinking bubble immediately when speaking starts

//       // Stop the animation after the thinking bubble has been shown for 3 seconds
//       bubbleTimer = setTimeout(() => {
//         setAnimate(false);
//       }, 3000);

//       // Ensure the thinking bubble is displayed for at least 3 seconds
//       hideBubbleTimer = setTimeout(() => {
//         setShowThinkingBubble(false);
//       }, 3000);

//     } else {
//       setAnimate(false);
//       // Additional timeout to manage rapid toggling of isSpeaking
//       setTimeout(() => {
//         setShowThinkingBubble(false);
//       }, 3000);
//     }

//     return () => {
//       clearTimeout(bubbleTimer);
//       clearTimeout(hideBubbleTimer);
//     };
//   }, [isSpeaking]);

//   const thinkingBubble = () => (
//     <div style={{
//       position: 'absolute',
//       top: '20px', // Adjusted for better visibility
//       left: '-80px', // Position to the left of the agent
//       width: '60px',
//       height: '40px',
//       border: '2px solid black',
//       borderRadius: '10px',
//       backgroundColor: 'white',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <span>...</span>
//     </div>
//   );

//   return (
//     <div style={{
//       width: '150px',
//       height: '150px',
//       position: 'relative',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       animation: animate ? 'glow 2s ease-out' : 'none'
//     }}>
//       <img src={femaleAgent} alt="Customer Support Agent" style={{ width: '100%', height: '100%', borderRadius: '50%' }}/>
//       {showThinkingBubble && thinkingBubble()}
//     </div>
//   );
// };

// export default AnimatedCharacter;






// import React from 'react';
// import femaleAgent from 'src\assets\female_agent.png'; // Adjust the path as necessary


// const AnimatedCharacter = ({ isSpeaking }) => {
//   const thinkingBubble = () => {
//     return (
//       <div style={{
//         position: 'absolute',
//         top: -40,
//         left: 30,
//         width: 60,
//         height: 40,
//         border: '2px solid black',
//         borderRadius: '10px',
//         backgroundColor: 'white',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center'
//       }}>
//         <span>...</span>
//       </div>
//     );
//   };

//   return (
//     <div style={{
//       width: '60px',
//       height: '60px',
//       position: 'relative',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center'
//     }}>
//       <img src={femaleAgent} alt="Customer Support Agent" style={{ width: '100%', height: '100%', borderRadius: '50%' }}/>
//       {isSpeaking && thinkingBubble()}
//     </div>
//   );
// };

// export default AnimatedCharacter;




// import React from 'react';
// import { motion } from 'framer-motion';

// const AnimatedCharacter = ({ isSpeaking, emotion }) => {
//   const mouthVariants = {
//     idle: { y: 0 },
//     speaking: {
//       y: [0, -2, 0],
//       transition: {
//         duration: 0.2,
//         repeat: Infinity,
//         repeatType: 'loop',
//       }
//     }
//   };

//   const eyeVariants = {
//     idle: { scale: 1 },
//     happy: { scale: [1, 1.2, 1], transition: { duration: 0.5, yoyo: Infinity } },
//     sad: { scaleY: 0.5, transition: { duration: 0.5, yoyo: Infinity } },
//     surprised: { scale: [1, 1.5, 1], transition: { duration: 0.5, yoyo: Infinity } }
//   };

//   return (
//     <div style={{
//       width: '60px',
//       height: '60px',
//       backgroundColor: 'lightgray',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       position: 'relative'
//     }}>
//       <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <rect x="3" y="3" width="18" height="18" rx="3" fill="#8B4513" stroke="black" strokeWidth="2"/>
//         <motion.circle
//           id="left-eye"
//           cx="8"
//           cy="10"
//           r="2"
//           fill="black"
//           animate={emotion}
//           variants={eyeVariants}
//         />
//         <motion.circle
//           id="right-eye"
//           cx="16"
//           cy="10"
//           r="2"
//           fill="black"
//           animate={emotion}
//           variants={eyeVariants}
//         />
//         <circle cx="8" cy="10" r="3" fill="none" stroke="black" strokeWidth="1"/>
//         <circle cx="16" cy="10" r="3" fill="none" stroke="black" strokeWidth="1"/>
//         <rect x="10" y="9.5" width="4" height="1" fill="black"/>
//         {/* <path d="M7 13 Q9 12 11 13 T15 13" stroke="black" strokeWidth="0.5" fill="none"/> */}
//         {/* <polygon points="10,20 8,22 10,24 12,22" fill="red"/>
//         <polygon points="14,20 16,22 14,24 12,22" fill="red"/>
//         <circle cx="12" cy="22" r="1" fill="red"/> */}
      
//       <motion.rect
//         x="7"
//         y="15"
//         width="10"
//         height="2"
//         fill="black"
//         animate={isSpeaking ? 'speaking' : 'idle'}
//         variants={mouthVariants}
//         style={{ position: 'absolute' }}
//       />
//       </svg>
//       {emotion === 'thinking' && (
//         <div style={{
//           position: 'absolute',
//           top: -40,
//           left: 30,
//           width: 60,
//           height: 40,
//           border: '2px solid black',
//           borderRadius: '10px',
//           backgroundColor: 'white',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center'
//         }}>
//           <span>...</span>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AnimatedCharacter;









// import React from 'react';
// import { motion } from 'framer-motion';

// const AnimatedCharacter = ({ isSpeaking }) => {
//   const mouthVariants = {
//     idle: { y: 0 },
//     speaking: {
//       y: [0, -2, 0],
//       transition: {
//         duration: 0.2,
//         repeat: Infinity,
//         repeatType: 'loop',
//       }
//     }
//   };

//   return (
//     <div
//       style={{
//         width: '200px',
//         height: '200px',
//         backgroundColor: 'lightgray',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         position: 'relative'
//       }}
//     >
//       <svg width="200" height="200" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <rect x="3" y="3" width="18" height="18" rx="3" fill="#8B4513" stroke="black" strokeWidth="2"/>
//         <circle cx="8" cy="10" r="2" fill="black"/>
//         <circle cx="16" cy="10" r="2" fill="black"/>
//         <circle cx="8" cy="10" r="3" fill="none" stroke="black" strokeWidth="1"/>
//         <circle cx="16" cy="10" r="3" fill="none" stroke="black" strokeWidth="1"/>
//         <rect x="10" y="9.5" width="4" height="1" fill="black"/>
//         {/* <path d="M7 13 Q9 12 11 13 T15 13" stroke="black" strokeWidth="0.5" fill="none"/> */}
       
//         {/* <polygon points="12,14 10,17 14,17" fill="red"/> */}
//         <polygon points="10,20 8,22 10,24 12,22" fill="red"/>
//         <polygon points="14,20 16,22 14,24 12,22" fill="red"/>
//         <circle cx="12" cy="22" r="1" fill="red"/>
//         <motion.rect
//           id="mouth"
//           x="7"
//           y="15"
//           width="10"
//           height="2"
//           fill="black"
//           animate={isSpeaking ? 'speaking' : 'idle'}
//           variants={mouthVariants}
//         />
//       </svg>
//     </div>
//   );
// };

// export default AnimatedCharacter;












// import React from 'react';
// import { motion } from 'framer-motion';

// const AnimatedCharacter = ({ isSpeaking }) => {
//   const mouthVariants = {
//     idle: { y: 0 },
//     speaking: {
//       y: [0, -2, 0],
//       transition: {
//         duration: 0.2,
//         repeat: Infinity,
//         repeatType: 'loop',
//       }
//     }
//   };

//   return (
//     <div
//       style={{
//         width: '200px',
//         height: '200px',
//         backgroundColor: 'lightgray',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         position: 'relative'
//       }}
//     >
//       <svg width="200" height="200" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <rect x="3" y="3" width="18" height="18" rx="3" fill="#C4C4C4" stroke="black" strokeWidth="2"/>
//         <circle cx="8" cy="10" r="2" fill="black"/>
//         <circle cx="16" cy="10" r="2" fill="black"/>
//         <motion.rect
//           id="mouth"
//           x="7"
//           y="15"
//           width="10"
//           height="2"
//           fill="black"
//           animate={isSpeaking ? 'speaking' : 'idle'}
//           variants={mouthVariants}
//         />
//       </svg>
//     </div>
//   );
// };

// export default AnimatedCharacter;






// import React from 'react';
// import { motion } from 'framer-motion';
// import { ReactComponent as BotSVG } from './assets/bot.svg'; // Import the SVG as a React component

// const AnimatedCharacter = ({ isSpeaking }) => {
//   const variants = {
//     idle: {
//       scale: 1,
//       rotate: 0,
//       transition: {
//         duration: 0.5,
//         repeat: Infinity,
//         repeatType: 'reverse',
//       }
//     },
//     speaking: {
//       scale: 1.2,
//       rotate: [0, 10, -10, 0],
//       transition: {
//         duration: 0.5,
//         repeat: Infinity,
//         repeatType: 'reverse',
//       }
//     }
//   };

//   return (
//     <motion.div
//       style={{
//         width: '200px',
//         height: '200px',
//         backgroundColor: 'lightgray', // Ensure container is visible
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//       }}
//       animate={isSpeaking ? 'speaking' : 'idle'}
//       variants={variants}
//     >
//       <BotSVG width="100%" height="100%" />
//     </motion.div>
//   );
// };

// export default AnimatedCharacter;




// import React, { useEffect, useRef } from 'react';
// import lottie from 'lottie-web';

// const AnimatedCharacter = ({ animationData, isSpeaking }) => {
//   const containerRef = useRef(null);

//   useEffect(() => {
//     const anim = lottie.loadAnimation({
//       container: containerRef.current,
//       renderer: 'svg',
//       loop: true,
//       autoplay: true,
//       animationData: animationData
//     });

//     return () => {
//       anim.destroy();
//       <div>TEST BOT</div>
//     };
//   }, [animationData]);

//   useEffect(() => {
//     if (isSpeaking) {
//       lottie.setDirection(1);
//     } else {
//       lottie.setDirection(-1);
//     }
//     lottie.play();
//   }, [isSpeaking]);

//   return <div ref={containerRef} style={{ width: 200, height: 200 }}></div>;
// };

// export default AnimatedCharacter;
